import { useDispatch, useSelector } from 'react-redux'

import type { RegisterRequestBody } from 'services/sso/types'
import { getRegisterFormStrings } from 'store/strings/selectors'
import { register } from 'store/user/actions'
import { CreateAccountForm } from 'ui-component-library/components/OrderConfirmation/LoginOrCreateAccount'

function CreateAccountFormContainer() {
  const {
    fullNameText,
    firstNameText,
    lastNameText,
    invalidNameText,
    yourBirthdayText,
    monthText,
    yearText,
    dayText,
    invalidBirthText,
    ageDisclaimerAccountText,
    emailText,
    invalidEmailText,
    emailConfirmText,
    invalidEmailConfirmText,
    passwordText,
    passwordConfirmText,
    invalidPasswordText,
    invalidPasswordConfirmText,
    passwordInstructionText,
    termsText,
    privacyText,
    invalidPrivacyTermsText,
    buttonText,
  } = useSelector(getRegisterFormStrings)
  const dispatch = useDispatch()

  function handleSubmit(params: RegisterRequestBody) {
    return register(params)(dispatch)
  }

  return (
    <CreateAccountForm
      onSubmit={handleSubmit}
      fullNameText={fullNameText}
      firstNameText={firstNameText}
      lastNameText={lastNameText}
      invalidNameText={invalidNameText}
      yourBirthdayText={yourBirthdayText}
      monthText={monthText}
      yearText={yearText}
      dayText={dayText}
      invalidBirthText={invalidBirthText}
      ageDisclaimerAccountText={ageDisclaimerAccountText}
      emailText={emailText}
      invalidEmailText={invalidEmailText}
      emailConfirmText={emailConfirmText}
      invalidEmailConfirmText={invalidEmailConfirmText}
      passwordText={passwordText}
      passwordConfirmText={passwordConfirmText}
      invalidPasswordText={invalidPasswordText}
      invalidPasswordConfirmText={invalidPasswordConfirmText}
      passwordInstructionText={passwordInstructionText}
      termsText={termsText}
      privacyText={privacyText}
      invalidPrivacyTermsText={invalidPrivacyTermsText}
      buttonText={buttonText}
    />
  )
}

export default CreateAccountFormContainer
